import { useDispatch } from "react-redux";
import { showMessage } from "app/store/actions/message.actions";

/**
 * Custom hook for handling API validation results
 */
export const useValidationHandler = () => {
  const dispatch = useDispatch();

  const handleValidation = response => {
    const validationResult = response?.payload?.validationResult;

    if (!validationResult) {
      return true;
    }

    if (!validationResult.success) {
      dispatch(showMessage({
        title: `${validationResult.title || "Validation Error"}`,
        variant: "warning",
        autoHideDuration: null,
        message: `${validationResult.errorMessage || "An error occurred"}`,
      }));
      return false;
    }

    return true;
  };

  return { handleValidation };
};
